import { createSelector } from "reselect";

export const notificationSelector = createSelector(
	(state) => state.app.get("allNotifications"),
	(allNotifications) => (allNotifications ? allNotifications.toJS() : null)
);
